import { ca } from '@cian/analytics';

export const trackSelectComplaint = (label: string) => {
  ca('event', {
    action: 'complain',
    category: 'Listing',
    label,
    name: 'oldevent',
  });
};
